export const isNotDefined = (someObject: any): boolean =>
  someObject === undefined || someObject === null
